import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import DataProvider from './providers/DataProvider';

import Header from './components/common/Header';
import Content from './components/Content';

import './App.css';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#334c68',
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: [
      'Nunito Sans',
      'DM Sans',
      'Roboto',
      'Helvetica',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif'
    ].join(','),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <DataProvider>
        <CssBaseline />
        <div className="App">
          <Header />
          <Content />
        </div>
      </DataProvider>
    </ThemeProvider>
  )
}

export default App;
